import * as React from "react";

function Confirmations1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M16.281 7.796l2.215-1.278A8.5 8.5 0 0013.5 3.633V6.19a5.993 5.993 0 012.781 1.607z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M18.895 9.76a7.25 7.25 0 010 4.48M17.388 16.851a7.25 7.25 0 01-3.88 2.24M10.493 19.092a7.25 7.25 0 01-3.88-2.24M5.105 14.24a7.25 7.25 0 010-4.48M6.612 7.149a7.25 7.25 0 013.88-2.24"
  }));
}

export default Confirmations1Icon;